import { render, staticRenderFns } from "./AddNewPartnerAPI.vue?vue&type=template&id=b958137c&scoped=true"
import script from "./AddNewPartnerAPI.vue?vue&type=script&lang=js"
export * from "./AddNewPartnerAPI.vue?vue&type=script&lang=js"
import style0 from "./AddNewPartnerAPI.vue?vue&type=style&index=0&id=b958137c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b958137c",
  null
  
)

export default component.exports